import cx from 'classnames'
import * as React from 'react'

import styles from './skeleton-place-holder.module.scss'

export type Props = {
  height?: string
  width?: string
  randomWidth?: boolean
  className?: string
}

const generateRandomNumberUpTo = (maxNumber: number) =>
  Math.floor(Math.random() * maxNumber) + 1

const SkeletonPlaceholder = ({
  randomWidth = false,
  height = '100%',
  width = '100%',
  className,
}: Props) => {
  const placeholderWidthPercentage = React.useMemo(() => {
    if (randomWidth) {
      const maxWidthPercentage = 80
      const randomOffset = generateRandomNumberUpTo(50)
      return `${maxWidthPercentage - randomOffset}%`
    }
    return width
  }, [width, randomWidth])

  return (
    <div
      style={{ width: placeholderWidthPercentage, height }}
      className={cx(styles['skeleton-placeholder'], className)}
    />
  )
}

export default SkeletonPlaceholder
